/**
 * @generated SignedSource<<0ef527af8370d8bb77e06db4f0dbe338>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { TimeZone } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type TimelineFragment$data = {
  readonly endDate: any;
  readonly online: boolean;
  readonly startDate: any;
  readonly steps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly date: any;
        readonly label: string;
      };
    }>;
  };
  readonly timezone: TimeZone;
  readonly " $fragmentType": "TimelineFragment";
};
export type TimelineFragment$key = {
  readonly " $data"?: TimelineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimelineFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimelineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "online",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimelineStepConnection",
      "kind": "LinkedField",
      "name": "steps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimelineStepEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimelineStep",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Timeline",
  "abstractKey": null
};

(node as any).hash = "8a2036e00792c3b2b3a435b059b8f514";

export default node;
